// Copyright (c) 2021 Siemens

/**
 *@module js/DesTeamService
 */
 import eventBus from 'js/eventBus';

const DES_TEAM_LIST_DELETETEAM = 'des-team-list.deleteTeam';

export const getSelectedTeamDetailsOpen = (vmo, apiOutput) => {
    const {
        data,
        dispatch
    } = vmo;
    const _ = require("lodash");
    const teamName = _.get(apiOutput, 'cellHeader1');
    const description = _.get(apiOutput, 'cellHeader2');
    data.teamName.uiValue = teamName;
    data.teamName.uiValues[0] = teamName;
    data.description.uiValue = description;
    data.description.uiValues[0] = description;
    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
};

export const getSelectedTeamDetails = (vmo, apiOutput) => {
    const {
        data,
        dispatch
    } = vmo;
    const _ = require("lodash");
    const name = _.get(apiOutput[0], 'cellHeader1');
    const description = _.get(apiOutput[0], 'cellHeader2');
    data.teamName.dbValue = name;
    data.teamName.dispValue = name;
    data.description.dbValue = description;
    data.description.dispValue = description;
    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
};

export const toggleDeleteTeamEvent = (isRemoveListner) => {
    if (true === isRemoveListner) {
        window.removeEventListener(DES_TEAM_LIST_DELETETEAM, deleteTeamHandler, false);
    } else {
        window.addEventListener(DES_TEAM_LIST_DELETETEAM, deleteTeamHandler, false);
    }
};

const deleteTeamHandler = (event) => {
    eventBus.publish('deleteSelectedTeam', {
        eventData: {
            teamId: event.detail.teamId
        }
    });
}
